/**
 * @file App enhancers
 * @module app.enhancer
 */
import { copyToClipboard, useQuasar } from 'quasar'
import { useToast } from 'vue-toastification'
import { useFavorites } from '@/stores/favorites'
import { useGlobalLoading } from '@/stores/loading'
// import { favoriteState } from '@/hooks/enums'

export const useEnhancer = () => {
  const $q = useQuasar()
  const toast = useToast()
  const storeFavorites = useFavorites()
  const storeGlobalLoading = useGlobalLoading()

  // const keepDefaultVariant = (isTryOn: boolean) => {
  //   $q.sessionStorage.set(hellooStorage.favorites, {
  //     variant: cloneDeep(storeFavorites.addToCartVariant.glassesVariant),
  //     isTryOn,
  //   })
  //   window.location.reload()
  // }

  // const getStorageDefaultVariant = () => {
  //   return $q.sessionStorage.getItem(hellooStorage.favorites) as AnyObject
  // }

  // const clearDefaultVariant = () => {
  //   $q.sessionStorage.remove(hellooStorage.favorites)
  // }

  const getMarkRead = () => $q.cookies.get('helloo_guiding') === 'true'
  const markRead = () => $q.cookies.set('helloo_guiding', 'true')
  const clearReadGuiding = () => $q.cookies.remove('helloo_guiding')
  const handleCopyContent = (text: string) => {
    copyToClipboard(text)
      .then(() => {
        toast.success('キャッシュにコピーされました')
      })
      .catch(() => {
        toast.error('ブラウザはコピーをサポートしていません')
      })
  }

  const openNewUrl = (url: string) => {
    window.open(url, '_blank') || window.location.assign(url)
  }

  return {
    getMarkRead,
    // favoriteState,
    toast,
    storeFavorites,
    storeGlobalLoading,
    markRead,
    clearReadGuiding,
    handleCopyContent,
    openNewUrl,
    // keepDefaultVariant,
    // getStorageDefaultVariant,
    // clearDefaultVariant,
  }
}
